import {Stack, styled} from '@mui/material';

export const StyledStack = styled(Stack)`
	background-color: ${({theme}) => theme.palette.other.planColor || theme.palette.primary.main};
	padding-inline: 16px;
	padding-bottom: 24px;
	gap: 16px;

	${({theme}) => theme.breakpoints.up('sm')} {
		padding-inline: 32px;
		padding-bottom: 16px;
		gap: 24px;
	}
`;
